import React from "react";
import { strings } from "../../Strings";

/**
 * 作業概要テーブルアイテムコンポーネント
 * @param {string} label ラベル
 * @param {string} value ラベル
 * @param {string} workType 作業種別
 * @param {boolean} isMain メインかどうか
 * @class SummaryItem
 */
const SummaryItem = ({ label, value, workType, isMain = false }) => (
  <div className={`summary-item ${isMain ? "summary-main" : ""}`}>
    <p className="summary-label">{label}</p>
    <p className={`summary-value ${isMain ? workType : ""}`}>{value}</p>
  </div>
);

/**
 * 作業概要テーブルヘッダーコンポーネント
 * @param {number} workType 作業種別
 * @param {string} workPlace 職場
 * @param {string} modelType 機種
 * @param {string} workProcess 工程
 * @param {string} modelNumber 機番
 * @class WorkContentTableHeader
 */
export default function WorkContentTableHeader({
  workType,
  workPlace,
  modelType,
  workProcess,
  modelNumber,
}) {
  const workTypeTarget = strings.WORK_TYPE_OPTIONS.find(
    (o) => o.value === workType,
  );
  return (
    <div className="compact-summary" aria-label="作業概要">
      <SummaryItem
        label="作業種別"
        value={workTypeTarget?.label}
        isMain
        workType={workTypeTarget?.name}
      />
      <SummaryItem label="職場" value={workPlace} />
      <SummaryItem label="機種" value={modelType} />
      <SummaryItem label="工程" value={workProcess} />
      <SummaryItem label="機番" value={modelNumber} />
    </div>
  );
}
